module.exports = __webpack_public_path__ + "img/brands-straatparkeren.bdee13f6.svg";